<template>
  <el-card>
    <div class="h-full" v-if="currentComp === 'TABLE'">
      <div class="flex mb-20px mr-10px">
        <el-input
          size="small"
          class="mr-10px !w-50"
          placeholder="请输入关键字"
          v-model="equipSearchData.keywords"
          clearable
        ></el-input>
        <el-select
          size="small"
          class="mr-10px !w-50"
          filterable
          placeholder="请选择风险区域"
          v-model="equipSearchData.associateRiskAreaId"
          clearable
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-date-picker
          class="mr-10px"
          v-model="equipSearchData.datePickerValue"
          format="yyyy-MM-dd"
          size="small"
          type="daterange"
          :clearable="true"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
        <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
        <el-button size="small" @click="resetText()">重置</el-button>
        <el-button
          size="small"
          type="primary"
          @click="handleEvent(null, 'create')"
          :disabled="!$hasAccess('create')"
          >新增</el-button
        >
        <el-button
          size="small"
          type="danger"
          @click="handleEvent(null, 'batchDelete')"
          :disabled="!$hasAccess('delete')"
          >批量删除</el-button
        >
        <el-button
          size="small"
          @click="handleEvent(null, 'batchImport')"
          :disabled="!$hasAccess('batchImport')"
          >导入</el-button
        >
      </div>
      <el-table
        :data="equipDataList"
        border
        class="w-full"
        :height="tableHeight"
        stripe
        v-loading="equipTableLoading"
        @selection-change="handleSelectionEquip"
      >
        <el-table-column type="selection" width="50"></el-table-column>
        <el-table-column label="序号" type="index" width="50"></el-table-column>
        <el-table-column
          label="承诺人"
          prop="pledgee"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="岗位"
          prop="post"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属风险点"
          prop="belongRiskPointStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="所属区域"
          prop="associateRiskAreasStr"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          label="主管领导"
          prop="supervisorLeadership"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="承诺时间" prop="commitmentTime" show-overflow-tooltip>
          <template slot-scope="scope">
            {{
              scope.row.commitmentTime
                ? dayjs(scope.row.commitmentTime).format('YYYY-MM-DD HH:mm:ss')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="300" fixed="right">
          <template slot-scope="scope">
            <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="equipTableSizeChange"
        @current-change="equipTableCurrentChange"
        :current-page.sync="equipPageConfig.SkipCount"
        :page-size.sync="equipPageConfig.MaxResultCount"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[15, 30, 45, 60, 75, 90]"
        :total="equipTotalCount"
        class="float-right mt-20px ml-10px"
      ></el-pagination>
    </div>

    <safe-duty-form
      v-if="currentComp === 'CREATE' || currentComp === 'UPDATE' || currentComp === 'READ'"
      :FormData="FormData"
      @refreshList="
        checkComp('TABLE')
        getEquipList()
      "
      @cancel="checkComp('TABLE')"
      :formProps="formProps"
    ></safe-duty-form>

    <safe-duty-card
      v-if="currentComp === 'CARD'"
      :FormData="FormData"
      :rowId="rowId"
      @cancel="checkComp('TABLE')"
    ></safe-duty-card>

    <wiz-upload-file
      v-dialogDrag
      :uploadFileProps="uploadFileProps"
      @exportTemplate="exportTemplate"
      @importTemplate="importTemplate"
      @exportResults="exportResults"
    ></wiz-upload-file>
  </el-card>
</template>

<script>
import dayjs from 'dayjs'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import { SecurityResponsibilityCommitmentCardApi } from '@wiz-api/double-prevention-management'
import { wizUploadFile } from '@wiz-core/compts'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import { AreaApi } from '@wiz-api/area-management'
import SafeDutyForm from '../../components/ThreeCardForm/SafeDutyForm'
import SafeDutyCard from '../../components/ThreeCardForm/SafeDutyCard'

const areaApi = new AreaApi()
const securityResponsibilityCommitmentCardApi = new SecurityResponsibilityCommitmentCardApi()

export default {
  name: 'safe-duty',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    SafeDutyForm,
    wizUploadFile,
    SafeDutyCard,
  },
  data() {
    return {
      rowId: '',
      currentComp: 'TABLE',
      uploadFileProps: {
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      areaList: [],
      FormData: {
        id: undefined,
        pledgeeId: undefined,
        pledgee: '',
        postId: undefined,
        post: '',
        belongRiskPoint: undefined,
        belongRiskPointStr: '',
        riskPointNumber: undefined,
        associateRiskAreas: undefined,
        associateRiskAreasStr: '',
        supervisorLeadershipId: undefined,
        supervisorLeadership: '',
        commitmentTime: undefined,
        commitmentContent: '',
        annex: undefined,
        associateRiskAreasArr: [],
      },
      formProps: {
        // create 新增 update 编辑 read 详情
        pageType: 'create',
      },
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        datePickerValue: [],
        associateRiskAreaId: undefined,
        keywords: '',
        commitmentTimeStart: undefined,
        commitmentTimeEnd: undefined,
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
    }
  },
  created() {
    this.getEquipList()
    this.getAreaList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
          {
            text: '复用',
            click: () => {
              return this.handleEvent(val, 'copy')
            },
            isShow: this.$hasAccess('copy'),
          },
          {
            text: '承诺卡',
            click: () => {
              return this.handleEvent(val, 'card')
            },
            isShow: this.$hasAccess('card'),
          },
        ]
      }
    },
  },
  methods: {
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 切换组件
    checkComp(name) {
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
      })
    },
    // 重置
    resetText() {
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 下载模板
    async exportTemplate() {
      const [err, res] = await securityResponsibilityCommitmentCardApi.importFromExcelTemplateFile()
      if (!err) {
        this.downLoadExcel('安全职责承诺卡模板', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await securityResponsibilityCommitmentCardApi.importFromExcelFile({
        input: formData.get('input'),
      })
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          this.FormData = this.$options.data().FormData
          this.initDialog(operation)
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await securityResponsibilityCommitmentCardApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await securityResponsibilityCommitmentCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            if (this.FormData.associateRiskAreas) {
              this.FormData.associateRiskAreasArr = this.FormData.associateRiskAreas.split(',')
            }
            this.initDialog(operation)
          }
          break
        case 'batchImport':
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'update':
          this.FormData = this.$options.data().FormData
          ;[err, res] = await securityResponsibilityCommitmentCardApi.get(row.id)
          if (!err) {
            this.FormData = {
              ...this.FormData,
              ...res,
            }
            console.log(this.FormData, 'FormData1122')
            if (this.FormData.associateRiskAreas) {
              this.FormData.associateRiskAreasArr = this.FormData.associateRiskAreas.split(',')
            }
            this.initDialog(operation)
          }
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await securityResponsibilityCommitmentCardApi.deleteMany({
                ids: this.selectionEquipData,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'card':
          this.rowId = row.id
          this.checkComp('CARD')
          break
        case 'copy':
          this.$confirm('是否复用当前记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await securityResponsibilityCommitmentCardApi.replicas({
                id: row.id,
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '复用成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})

          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.formProps.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values.map((item) => {
        return item.id
      })
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      this.equipSearchData.commitmentTimeStart =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[0]).format('YYYY-MM-DD')
          : undefined
      this.equipSearchData.commitmentTimeEnd =
        this.equipSearchData.datePickerValue && this.equipSearchData.datePickerValue.length === 2
          ? dayjs(this.equipSearchData.datePickerValue[1]).format('YYYY-MM-DD')
          : undefined
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...this.equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await securityResponsibilityCommitmentCardApi.pagedListQuery(data)
      if (!err) {
        this.equipDataList = res.items
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
